export const locale = {
  lang: "fr-CA",
  data: {
    ORG: {
      GRAPHICS: "Graphiques",
      LOGO: "Logo",
      UPLOAD_LOGO: "Téléverser Logo",
      UPLOAD_LOGO_SUCCESS: "Logo téléversé avec succès",
      UPLOAD_LOGO_DIMENSION: "largeur et hauteur minimale: 200px",
      UPLOAD_HEADER: "Téléverser Header",
      UPLOAD_HEADER_SUCCESS: "Header téléversé avec succès",
      UPLOAD_HEADER_DIMENSION: "largeur minimale: 600px, hauteur minimale: 120px",
      SELECT_LOCALES: "Choissiser une ou plusieurs langue pour votre organisation dans la liste ci-dessous.",
      SELECT_DEFAULT_LOCALES: "Choisir la langue par défaut pour cette organisation",
      CURRENT_LOGO: "Logo",
      CURRENT_REPORT_HEADER: "En-tête des rapports",
      CURRENT_REPORT_ASSETS: "Éléments graphique des rapports",
      NEXT_PAYMENT_DATE: "Prochain paiement",
      OPEN_SINCE: "Ouvert depuis",
      TOTAL_USER: "Nombre d'utilisateurs",
      CURRENT_COST: "Coût mensuel actuel",
      RESPONSIBLE_USER: "Utilisateur responsable",
      ORG_LIST: "Liste des traiteurs",
      TRIAL: "Trial",
      SUPPORT_EMAIL: "Courriel du support",
      SUPPORT_TEL: "Téléphone du support",
      SIGNATURE: "Signature",
      LOGO_WHITE: "Logo Blanc",
      LOGO_COLOR: "Logo Couleur",
      UPLOAD_LOGO_TYPE: "Téléverser",
      UPLOAD_LOGO_TYPE_SUCCESS: "Logo téléversé avec succès",
      UPLOAD_LOGO_TYPE_ERROR: "Erreur lors du téléversement du logo",
      LOGO_PNG_ONLY: "PNG seulement, 272x72 pixels",
      LOGO_INVALID_DIMENSIONS: "L'image doit faire 272x72 pixels",
      LOGO_INVALID_FORMAT: "Seuls les fichiers PNG sont acceptés",
      PRODUCT_DEFAULT_IMAGE: "Image produit par défaut",
      PRODUCT_DEFAULT_PNG_ONLY: "PNG seulement, 250x250 pixels",
      PRODUCT_DEFAULT_INVALID_DIMENSIONS: "L'image doit faire 250x250 pixels",
      PRODUCT_DEFAULT_UPLOAD_SUCCESS: "Image téléversée avec succès",
      PRODUCT_DEFAULT_UPLOAD_ERROR: "Erreur lors du téléversement de l'image",
      COLORS: "Couleurs",
      MANAGE_TAX_NUMBERS: "Gestion des numéros de taxes",
      EMAIL_BG_COLOR: "Couleur de l'en-tête du courriel",
      EMAIL_BG_COLOR_HELP:
        "Couleur de la bande d'en-tête/pied et des boutons primaires dans les courriels envoyés. Laissez vide pour utiliser la couleur par défaut.",
      EMAIL_BG_COLOR_CLEAR: "Effacer",
      EMAIL_BG_COLOR_SAVED: "Couleur de l'en-tête du courriel enregistrée",
      IDENTITIES: "Identités d'organisation",
      IDENTITY_ADD: "Ajouter une identité",
      IDENTITY_EDIT: "Modifier l'identité",
      IDENTITY_NAME: "Nom",
      IDENTITY_THEME_COLOR: "Couleur du thème",
      IDENTITY_EMAIL_BG_COLOR: "Couleur de l'en-tête du courriel",
      IDENTITY_EMAIL_BG_COLOR_HELP:
        "Si vide, la couleur de l'organisation parente est utilisée.",
      IDENTITY_EMPTY: "Aucune identité",
      IDENTITY_SAVE_FIRST:
        "Enregistrez d'abord l'identité pour téléverser les logos.",
      IDENTITY_CREATE_SUCCESS: "Identité créée avec succès!",
      IDENTITY_UPDATE_SUCCESS: "Identité modifiée avec succès!",
      IDENTITY_DELETE_SUCCESS: "Identité supprimée avec succès!",
      IDENTITY_NEW: "Nouvelle identité",
      IDENTITY_TITLE: "Identité d'organisation",
      IDENTITY_COLORS: "Couleurs",
      IDENTITY_NOT_FOUND: "Identité introuvable",
    },
  },
};
